import { render, staticRenderFns } from "./recently_updated.vue?vue&type=template&id=4a27e1bd&"
import script from "./recently_updated.vue?vue&type=script&lang=js&"
export * from "./recently_updated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports